import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../api/apiInstance';
import { RootState } from '../../store/store';
import { CourtLocationForm } from 'src/utils/constant';

export const editCourtLocation = createAsyncThunk(
  'user/editCourtLocation',
  async (courtLocation: CourtLocationForm, { rejectWithValue }) => {
    try {
      const response = await apiInstance.patch('/profile', {
        courtLocation,
      });
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response.data.message);
    }
  },
);

export const editReturnAddress = createAsyncThunk(
  'user/editReturnAddress',
  async (_, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const formData = state.settings.returnAddress;
    try {
      const response = await apiInstance.put('/profile/return-addresses', {
        ...formData.formData,
      });
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response.data.message);
    }
  },
);

export const addReturnAddress = createAsyncThunk('user/addReturnAddress', async (_, { getState, rejectWithValue }) => {
  const state = getState() as RootState;
  const formData = state.settings.returnAddress;
  try {
    const response = await apiInstance.post('/profile/return-addresses', {
      ...formData.formData,
    });
    return response.data;
  } catch (err: any) {
    return rejectWithValue(err.response.data.message);
  }
});

export const changeIsDefaultReturnAddress = createAsyncThunk(
  'user/changeIsDefaultReturnAddress',
  async (isDefault: boolean, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const formData = state.settings.returnAddress;
    try {
      const response = await apiInstance.put('/profile/return-addresses', {
        ...formData.formData,
        isDefault,
      });
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response.data.message);
    }
  },
);

export const getReturnAddresses = createAsyncThunk('user/getReturnAddresses', async (_, { rejectWithValue }) => {
  try {
    const response = await apiInstance.get('/profile/return-addresses');
    return response.data;
  } catch (err: any) {
    return rejectWithValue(err.response.data.message);
  }
});

export const deleteReturnAddress = createAsyncThunk(
  'user/deleteReturnAddress',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(`/profile/return-addresses/${id}`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response.data.message);
    }
  },
);

export const editSignature = createAsyncThunk('user/editSignature', async (_, { getState, rejectWithValue }) => {
  const state = getState() as RootState;
  const formData = state.settings.signature;
  const formattedSignature = Object.fromEntries(
    Object.entries(formData.formData).map(([k, v]) => [k, v === '' ? null : v]),
  );
  const formattedPhone = formattedSignature.phone ? formattedSignature.phone.replace(/\D/g, '') : ''
   try {
    const response = await apiInstance.put('/profile/signatures', {
      ...formattedSignature,
      phone: formattedPhone
    });
    return response.data;
  } catch (err: any) {
    return rejectWithValue(err.response.data.message);
  }
});

export const changeIsDefaultSignature = createAsyncThunk(
  'user/changeIsDefaultSignature',
  async (isDefault: boolean, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const formData = state.settings.signature;
    try {
      const response = await apiInstance.put('/profile/signatures', {
        ...formData.formData,
        isDefault,
      });
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response.data.message);
    }
  },
);

export const addSignature = createAsyncThunk('user/addSignature', async (_, { getState, rejectWithValue }) => {
  const state = getState() as RootState;
  const formData = state.settings.signature;
  const formattedSignature = Object.fromEntries(
    Object.entries(formData.formData).map(([k, v]) => [k, v === '' ? null : v]),
  );
  const formattedPhone = formattedSignature.phone ? formattedSignature.phone.replace(/\D/g, '') : ''
  try {
    const response = await apiInstance.post('/profile/signatures', {
      ...formattedSignature,
      phone: formattedPhone
    });
    return response.data;
  } catch (err: any) {
    return rejectWithValue(err.response.data.message);
  }
});

export const deleteSignature = createAsyncThunk('user/deleteSignature', async (id: number, { rejectWithValue }) => {
  try {
    const response = await apiInstance.delete(`/profile/signatures/${id}`);
    return response.data;
  } catch (err: any) {
    return rejectWithValue(err.response.data.message);
  }
});

export const getSignatures = createAsyncThunk('user/getSignatures', async (_, { rejectWithValue }) => {
  try {
    const response = await apiInstance.get(`/profile/signatures/`);
    return response.data;
  } catch (err: any) {
    return rejectWithValue(err.response.data.message);
  }
});

export const getUserProfile = createAsyncThunk('user/get-profile', async (_, { rejectWithValue }) => {
  try {
    const response = await apiInstance.get('/profile');
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.response.data.message);
  }
});
